/**
 * Zero-Result-OR-Fallback Banner-Gating (Sprint 5) — pure, DOM-frei, testbar.
 *
 * LibraryPage ist zu hook-schwer für sinnvolles Full-Page-RTL (kein Page-Test im
 * Repo); die testbare Such-Banner-Entscheidung lebt darum als pure Funktion hier
 * (Muster wie `active-filters.ts`, `library-neighbors.ts`). `resolveSearchBanner`
 * mappt den aktuellen Such-/Listen-Zustand auf genau einen Banner-/Empty-State.
 *
 *  - `'or-active'`    — OR-Modus aktiv, es gibt Treffer → Hinweis-Banner ÜBER der
 *                       Liste („zeige Treffer für mindestens einen Begriff").
 *                       NUR bei `listLength > 0` (Codex R1-F4: nie über leerem Grid).
 *  - `'or-empty'`     — OR-Modus aktiv, 0 Treffer (z.B. Direct-Link) → Empty-
 *                       Variante „auch keine Treffer für mindestens einen".
 *  - `'or-fallback'`  — AND-Modus, 0 Treffer, aber OR-Count `N > 0` → Fallback
 *                       anbieten („N für mindestens einen anzeigen").
 *  - `'default-empty'`— AND-Modus, 0 Treffer, kein/0 OR-Fallback → normaler
 *                       Empty-State (Filter-Reset / Upload).
 *  - `'none'`         — Liste lädt/fehlerhaft ODER AND-Modus mit Treffern → kein
 *                       Banner.
 */
export type SearchBannerState =
  | 'or-active'
  | 'or-empty'
  | 'or-fallback'
  | 'default-empty'
  | 'none';

export interface SearchBannerInput {
  /** `match=or` in der URL aktiv? */
  isOrMode: boolean;
  /** Status der Ergebnis-Liste (`useInfiniteAssets`). */
  listStatus: 'loading' | 'ok' | 'error';
  /** Anzahl geladener Treffer. */
  listLength: number;
  /** OR-Trefferzahl aus `/stats?match=or`; `null` = unbekannt/loading/error. */
  orFallbackCount: number | null;
}

export function resolveSearchBanner({
  isOrMode,
  listStatus,
  listLength,
  orFallbackCount,
}: SearchBannerInput): SearchBannerState {
  if (listStatus !== 'ok') return 'none';
  if (listLength > 0) return isOrMode ? 'or-active' : 'none';
  // Ab hier: 0 Treffer.
  if (isOrMode) return 'or-empty';
  if (orFallbackCount !== null && orFallbackCount > 0) return 'or-fallback';
  return 'default-empty';
}
